<template>
  <div class="content">
    <h1 class="content__title" v-text="texts.title"></h1>
    <span class="content__details" v-text="texts.subtitle"></span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Datos del Usuario</h2>

          <div class="waiting" v-if="loading">
            <img src="/static/img/waiting.gif" alt="Cargando Información" class="waiting__image">
          </div>

          <form class="form" @submit.prevent="saveUser" v-if="!loading">
            <div class="form__fielset">

              <div class="form__container form__container--short">
                <label for="first_name" class="form__label form__label--required">Primer Nombre</label>
                <input type="text" class="form__input" name="first_name" id="first_name" placeholder="Primer Nombre" v-model="user.first_name" v-validate="validation.first_name">
                <span v-show="errors.has('first_name')" class="form__alert">{{ errors.first('first_name') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="middle_name" class="form__label">Segundo Nombre</label>
                <input type="text" class="form__input" name="middle_name" id="middle_name" placeholder="Segundo Nombre" v-model="user.middle_name" v-validate="validation.middle_name">
                <span v-show="errors.has('middle_name')" class="form__alert">{{ errors.first('middle_name') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="last_name" class="form__label form__label--required">Primer Apellido</label>
                <input type="text" class="form__input" name="last_name" id="last_name" placeholder="Primer Apellido" v-model="user.last_name" v-validate="validation.last_name">
                <span v-show="errors.has('last_name')" class="form__alert">{{ errors.first('last_name') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="second_last_name" class="form__label">Segundo Apellido</label>
                <input type="text" class="form__input" name="second_last_name" id="second_last_name" placeholder="Segundo Apellido" v-model="user.second_last_name" v-validate="validation.second_last_name">
                <span v-show="errors.has('second_last_name')" class="form__alert">{{ errors.first('second_last_name') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="phone" class="form__label">Teléfono</label>
                <input type="text" class="form__input" name="phone" id="phone" placeholder="+52 1 (000) 000 00 00" v-model="user.phone" v-validate="validation.phone">
                <span v-show="errors.has('phone')" class="form__alert">{{ errors.first('phone') }}</span>
              </div>

              <div class="form__container">
                <div class="form__checkbox-container">
                  <input type="checkbox" name="phone_verified" value="1" id="phone_verified" v-model="user.phone_verified" v-validate="validation.phone_verified">
                  <label for="phone_verified">
                    <span></span> Teléfono Verificado
                  </label>
                </div>
                <span v-show="errors.has('phone_verified')" class="form__alert">{{ errors.first('phone_verified') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="facebook_id" class="form__label">Id de Facebook</label>
                <input type="text" class="form__input" name="facebook_id" id="facebook_id" placeholder="1234567890" v-model="user.facebook_id" v-validate="validation.facebook_id">
                <span v-show="errors.has('facebook_id')" class="form__alert">{{ errors.first('facebook_id') }}</span>
              </div>

              <h2 class="main__title">Datos de Acceso</h2>

              <div class="form__container form__container--half">
                <label for="email" class="form__label form__label--required">Email</label>
                <input type="email" class="form__input" name="email" id="email" placeholder="Correo Electrónico" v-model="user.email" v-validate="validation.email">
                <span v-show="errors.has('email')" class="form__alert">{{ errors.first('email') }}</span>
              </div>

              <div class="form__container">
                <div class="form__checkbox-container">
                  <input type="checkbox" name="email_verified" value="1" id="email_verified" v-model="user.email_verified" v-validate="validation.email_verified">
                  <label for="email_verified">
                    <span></span> Correo Verificado
                  </label>
                </div>
                <span v-show="errors.has('email_verified')" class="form__alert">{{ errors.first('email_verified') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="password" class="form__label" :class="{'form__label--required': $route.name === 'userNew'}">Contraseña</label>
                <input type="password" class="form__input" name="password" id="password" placeholder="*************" v-model="user.password" v-validate="validation.password" ref="password">
                <span v-show="errors.has('password')" class="form__alert">{{ errors.first('password') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="confirm_password" class="form__label" :class="{'form__label--required': $route.name === 'userNew'}">Confirmar Contraseña</label>
                <input type="password" class="form__input" name="confirm_password" id="confirm_password" placeholder="*************" v-model="user.confirm_password" v-validate="validation.confirm_password">
                <span v-show="errors.has('confirm_password')" class="form__alert">{{ errors.first('confirm_password') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="status_id" class="form__label form__label--required">Estatus</label>
                <div class="form__select-container">
                  <select name="status_id" id="status_id" class="form__select" v-validate="validation.estatus_id" v-model="user.status_id">
                    <option :value="null">Seleccionar Estatus</option>
                    <option v-for="(status, index) in statusList" :key="index" :value="status.id" v-text="status.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('status_id')" class="form__alert">{{ errors.first('status_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="role_id" class="form__label form__label--required">Rol de Usuario</label>
                <div class="form__select-container">
                  <select name="role_id" id="role_id" class="form__select" v-validate="validation.role_id" v-model="user.role_id">
                    <option :value="null">Seleccionar Rol</option>
                    <option v-for="(role, index) in roles" :key="index" :value="role.id" v-text="role.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('role_id')" class="form__alert">{{ errors.first('role_id') }}</span>
              </div>

              <input type="submit" class="btn btn__default btn--regular" :value="texts.submit">

            </div>
          </form>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">OPCIONES</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'userList'}">Lista de Usuarios</router-link>
        <router-link v-if="$route.name === 'userEdit'" class="btn btn--small btn__default" :to="{name: 'userNew'}">Nuevo Usuario</router-link>
      </aside>
    </div>
  </div>
</template>

<script>
import httpService from '@/api/request'
import {validation, UserFields, statusList, texts} from './mocks'
export default {
  mixins: [httpService],
  data: function () {
    return {
      validation: validation,
      user: null,
      roles: [],
      statusList: statusList
    }
  },
  created: function () {
    this.start()
  },
  watch: {
    '$route.path': function () {
      this.start()
    }
  },
  methods: {
    start: function () {
      this.getRoles()
      if (this.userId) {
        this.getUser()
      }
      if (!this.userId) {
        this.user = new UserFields()
      }
    },
    getUser: function () {
      let httpRequest = {
        params: '',
        module: 'users'
      }
      this.getById(this.userId, httpRequest)
        .then(
          user => {
            this.user = user.data
          }
        )
        .catch(
          () => {
            this.$router.push({name: 'userNew'})
          }
        )
    },
    getRoles: function () {
      let httpRequest = {
        params: '',
        module: 'roles'
      }
      this.get(httpRequest)
        .then(
          roles => {
            this.roles = roles.data
          }
        )
    },
    saveUser: function () {
      this.$validator.validateAll()
        .then(
          response => {
            if (response) {
              let httpRequest = {
                params: '',
                module: 'users',
                element: this.user
              }
              let request
              if (this.$route.name === 'userEdit') {
                request = this.put(this.userId, httpRequest)
              } else if (this.$route.name === 'userNew') {
                request = this.post(httpRequest)
              }
              request.then(
                response => {
                  this.$store.commit('notificate', {
                    title: this.texts.messages.success.title,
                    text: this.texts.messages.success.text,
                    type: 'success'
                  })
                  if (this.$route.name === 'userNew') {
                    this.$router.push({name: 'userEdit', params: {id: response.data.current_id}})
                  }
                }
              )
            } else {
              this.$store.commit('notificate', {
                title: 'CAMPOS REQUERIDOS',
                text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
                type: 'warn'
              })
            }
          }
        ).catch(
          error => {
            console.log(error)
          }
        )
    }
  },
  computed: {
    userId: function () {
      return this.$route.params.id
    },
    loading: function () {
      return this.$route.params.id && !this.user
    },
    texts: function () {
      return texts[this.$route.name]
    }
  }
}
</script>

<style lang="sass">
@import "../../assets/sass/objects/_btns"
@import "../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/users/edit.vue